/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface AddReferenceToOrderRequest {
  id?: string;
  reference?: Reference;
}

export interface AddReferenceToOrderResponse {
  order?: Order;
}

/** Describes an additional service provided by shipping method. */
export interface Addon {
  /**
   * Carrier addon code.
   * A list of available options present in service-carrier-products in addons.json[].code field.
   * For delivery addons it is empty - use carrier_name.
   * For default addons it is present.
   */
  carrier_code?: string;
  /**
   * Carrier addon name.
   * A list of available options present in service-carrier-products in addons.json[].name field.
   * For delivery addon of TYPE_CARRIER it is present, for other types it is empty.
   * For default addons it is present.
   */
  carrier_name?: string;
  /** Description of the addon. */
  description?: string;
  /**
   * External identifier of the addon (merchant's id).
   * For delivery addons it is delivery addon external_id.
   * For default addons it is empty.
   */
  external_id?: string;
  /**
   * Internal identifier of the addon.
   * For delivery addons it is delivery addon id.
   * For default addons it is empty.
   */
  id?: string;
  /** Name of the addon. Presented to the customer. */
  name?: string;
  /**
   * Price of the addon.
   * @format int32
   */
  price?: number;
  /** Type of that addon. */
  type?: Type;
}

/** Common address entity that used almost everywhere in Ingrid's API. */
export interface Address {
  /** List of address lines part of address such as street and building number */
  address_lines?: string[];
  /** Number of the apartment. */
  apartment_number?: string;
  /**
   * Attention field. Can be used to indicate an employee if the address is a
   * company address [optional]
   */
  attn?: string;
  /** in the UK some buildings do not have a number, only a name */
  building_name?: string;
  /** Care of part of address usually written as `c/o` [optional] */
  care_of?: string;
  /** Name of the city */
  city?: string;
  /**
   * Geolocation coordinates of the address. If reverse geolocation lookup of the
   * address was successful this property will be populated. If coordinates are
   * available they will be used to in service point search. In case of
   * `search_address` coordinates can also be set by merchant if known.
   */
  coordinates?: Coordinates;
  /**
   * Country should be specified as two uppercase letters (ISO Alpha-2).
   * Example `SE` for Sweden, `ES` for Spain.
   */
  country?: string;
  /** The door code to the main entrance of the building if applicable [optional] */
  door_code?: string;
  /** Floor number [optional] */
  floor_number?: string;
  /** Customer or company name */
  name?: string;
  /** ID of the PO Box [optional] */
  po_box_id?: string;
  /** Postal code (or zipcode in US) */
  postal_code?: string;
  /** Region can be a state or a province [optional] */
  region?: string;
  /** Name of the street. */
  street?: string;
  /** Number of the street. */
  street_number?: string;
  /**
   * Further division of regions. Example countries are GB, IE, IT, LT, MX
   * For example for The Republic Of Ireland there are 4 provinces (regions),
   * e.g. `Connacht` and 26 counties (subregions), e.g. `Galway`
   * Format is ISO 3166 where applicable, exceptions are e.g. Mexico [optional]
   */
  subregion?: string;
}

export interface Any {
  "@type"?: string;
  [key: string]: any;
}

export interface Cart {
  attributes?: string[];
  cart_id?: string;
  currency?: string;
  items?: CartItem[];
  pre_order?: boolean;
  /** Provides a date interval. Depending on a case, `start` and `end` parts are not guaranteed to be present. */
  shipping_date?: DateTimeRange;
  /** @format int32 */
  total_discount?: number;
  /** @format int32 */
  total_value?: number;
  /** Use vouchers instead. [deprecated] */
  voucher?: string;
  vouchers?: string[];
}

export interface CartItem {
  attributes?: string[];
  country_of_origin?: string;
  currency?: string;
  /** Dimensions of this cart item. */
  dimensions?: Dimensions;
  /** @format int32 */
  discount?: number;
  hs_code?: string;
  image_url?: string;
  name?: string;
  out_of_stock?: boolean;
  /** @format int32 */
  price?: number;
  /**
   * Quantity of this item.
   * @format int32
   */
  quantity?: number;
  sku?: string;
  /**
   * Weight of the object in grams.
   * @format int32
   */
  weight?: number;
}

/**
 *  - UNSPECIFIED: No consent given, no data collection allowed.
 *  - STATISTICAL: Statistical consent given, data can be collected for statistical purposes only.
 *  - PERSONALIZATION: Personalization consent given, data can be collected for personalization purposes.
 * @default "UNSPECIFIED"
 */
export type ConsentLevel = "UNSPECIFIED" | "STATISTICAL" | "PERSONALIZATION";

export interface ContactInfo {
  /** Common address entity that used almost everywhere in Ingrid's API. */
  address?: Address;
  email?: string;
  external_id?: string;
  location_ref?: string;
  national_identification_number?: string;
  national_identification_number_encrypted?: string;
  phone?: string;
}

/** Geolocation coordinates */
export interface Coordinates {
  /**
   * Latitude
   * @format double
   */
  lat?: number;
  /**
   * Longitude
   * @format double
   */
  lng?: number;
}

export interface CountOrdersResponse {
  /** The counts of orders grouped by source */
  counts?: OrderCount[];
}

export interface CreateOrderRequest {
  cart?: Cart;
  external?: External;
  master_session_id?: string;
  notes?: Notes;
  receiver?: Receiver;
  route?: Route;
  sender?: Sender;
  /** Session contains details of the session, which was used to create this order. */
  session?: Session;
  /** Source is the name of the system, which created this order. [required] */
  source?: string;
}

export interface CreateOrderResponse {
  order?: Order;
}

export interface CustomShippingLocation {
  added_at?: string;
  location_ref?: string;
  shipping_method?: string;
}

/** Provides a date interval. Depending on a case, `start` and `end` parts are not guaranteed to be present. */
export interface DateTimeRange {
  /** End of the interval. Date is returned in RFC3339 format. Example `2018-09-08T22:47:31Z`. */
  end?: string;
  /** Start of the interval. Date is returned in RFC3339 format. Example `2018-09-08T22:47:31Z` */
  start?: string;
}

/** Listing of Delivery Time Components produced by the Ingrid Delivery Checkout. */
export interface DeliveryPromise {
  /** The Date & Time response returned by Ingrid Carrier integrations that specify when carriers say they could deliver the parcel. This notion could differ from customer_delivery_promise since a carrier could have deliveries on eg. Saturdays but a user has configured Ingrid Delivery Checkout to communicate only business days. For such situation, Ingrid would move the customer_delivery_promise to the next possible business day. */
  carrier_delivery_promise?: DateTimeRange;
  /** The date & time used to present the delivery time promise to the end user. (When time is set to 00:00 it means Ingrid has presented a set of days or business days e.g. 2-3 Business days). */
  customer_delivery_promise?: DateTimeRange;
  /** The date & time when the parcel is understood by Ingrid Delivery Checkout and is possible to collect from Merchant Warehouse or Store. */
  pickup_from_merchant?: DateTimeRange;
}

/**
 * Indicates the type of the delivery
 * - UNKNOWN: Delivery type is not known for some reason
 *  - DELIVERY: Home delivery
 *  - PICKUP: Delivery to a service point or a locker
 *  - MAILBOX: Delivery to customer's mailbox
 *  - INSTORE: Delivery to one of the merchants stores
 *  - INWAREHOUSE: Delivery to the warehouse. This type is used with chain delivery in warehouse-warehouse-delivery/pickup.
 * @default "UNKNOWN"
 */
export type DeliveryType = "UNKNOWN" | "DELIVERY" | "PICKUP" | "MAILBOX" | "INSTORE" | "INWAREHOUSE";

/** Dimensions of an item in millimeters. */
export interface Dimensions {
  /**
   * Height of the item in millimeters.
   * @format int32
   */
  height?: number;
  /**
   * Length of the item in millimeters.
   * @format int32
   */
  length?: number;
  /**
   * Width of the item in millimeters.
   * @format int32
   */
  width?: number;
}

export interface External {
  /** Reference Ids is a read only field, containing values from references.id. [deprecated] */
  reference_ids?: string[];
  references?: Reference[];
}

export interface GetOrderResponse {
  order?: Order;
}

/** LegLocation represents a location that takes part in a delivery. */
export interface LegLocation {
  /**
   * Address of a location. This is optional when LocationType is WAREHOUSE or HOME,
   * since these values can be obtained from the order.
   */
  address?: Address;
  external_id?: string;
  /** LegLocationType represents a type of a location that takes part in a delivery. */
  location_type?: LegLocationType;
}

/**
 * LegLocationType represents a type of a location that takes part in a delivery.
 * @default "UNKNOWN_LOCATION_TYPE"
 */
export type LegLocationType =
  | "UNKNOWN_LOCATION_TYPE"
  | "WAREHOUSE_LOCATION_TYPE"
  | "STORE_LOCATION_TYPE"
  | "HOME_LOCATION_TYPE"
  | "PICKUP_POINT_LOCATION_TYPE";

export interface ListOrdersLogRequest {
  last_id?: string;
  last_updated_at?: string;
}

export interface ListOrdersLogResponse {
  orders?: Order[];
}

export interface ListOrdersResponse {
  orders?: Order[];
  /** @format uint64 */
  total_count?: number;
}

/** MasterSession contains details about the multi session witch was used to create this order. */
export interface MasterSession {
  id?: string;
  tos_ids?: string[];
}

export interface Metadata {
  /** MasterSession contains details about the multi session witch was used to create this order. */
  master_session?: MasterSession;
  /** Identifier of master session for sessions being part of split shipment. */
  master_session_id?: string;
  /** Session contains details of the session, which was used to create this order. */
  session?: Session;
  /** Source is the name of the system, which created this order. */
  source?: string;
}

export interface Notes {
  description?: string;
}

export interface OperationalHours {
  /**
   * Free text operational hours. Used as a fallback when the
   * operational hours cannot be parsed correctly
   */
  free_text?: string[];
  /** Friday */
  fri?: string;
  /** Monday */
  mon?: string;
  /** Saturday */
  sat?: string;
  /** Sunday */
  sun?: string;
  /** Thursday */
  thu?: string;
  /** Tuesday */
  tue?: string;
  /** Wednesday */
  wed?: string;
}

export interface Order {
  cart?: Cart;
  created_at?: string;
  external?: External;
  id?: string;
  metadata?: Metadata;
  notes?: Notes;
  receiver?: Receiver;
  route?: Route;
  sender?: Sender;
  site_id?: string;
  status?: Status;
  updated_at?: string;
}

/** The count of orders for a specific source */
export interface OrderCount {
  /** @format int64 */
  count?: number;
  source?: string;
}

/**
 * Indicates the kind of pickup location
 * - UNKNOWN_PICKUP_LOCATION_TYPE: Location type is not known for some reason
 *  - LOCKER: Locker location type. Example Instabox or a DHL locker
 *  - STORE: Can be a merchant's store or any other store that handles logistics
 *  - POSTOFFICE: Postal office
 *  - MANNED: A manned service point
 * @default "UNKNOWN_PICKUP_LOCATION_TYPE"
 */
export type PickupLocationType = "UNKNOWN_PICKUP_LOCATION_TYPE" | "LOCKER" | "STORE" | "POSTOFFICE" | "MANNED";

export interface PickupPointDetails {
  /** Common address entity that used almost everywhere in Ingrid's API. */
  address?: Address;
  location_ref?: string;
  /**
   * - UNKNOWN_PICKUP_LOCATION_TYPE: Location type is not known for some reason
   *  - LOCKER: Locker location type. Example Instabox or a DHL locker
   *  - STORE: Can be a merchant's store or any other store that handles logistics
   *  - POSTOFFICE: Postal office
   *  - MANNED: A manned service point
   */
  location_type?: PickupLocationType;
  name?: string;
  /** Operational hours at the time of creating the order. */
  operational_hours?: OperationalHours;
}

export interface Pricing {
  currency?: string;
  /** @format int32 */
  shipping_price?: number;
}

export interface Receiver {
  /** Billing details. This is an optional field, only needed if billing data is different then ContactInfo. */
  billing?: ContactInfo;
  contact_info?: ContactInfo;
  courier_instructions?: string;
  /** customer_number is carrier customer number provided by a customer during checkout. This field is used during booking with DHL. */
  customer_number?: string;
  /** Destination details. This is an optional field, only needed if shipping location is different then ContactInfo. */
  destination?: ContactInfo;
  door_code?: string;
  /** pickup_point_details is only used when delivery is to pickup point or store. */
  pickup_point_details?: PickupPointDetails;
}

export interface Reference {
  id?: string;
  name?: string;
}

/** Contains promise for returns and exchanges */
export interface ReturnsPromise {
  currency_code?: string;
  /** @format int64 */
  exchange_cost?: string;
  /** true if exchanges are enabled, false if not, check exchange_cost for the cost */
  exchanges_enabled?: boolean;
  id?: string;
  /**
   * IsUnavailable is a flag that indicates if the return promise is missing
   * false: not missing, use data to display return promise
   * true: missing, eg in case of api failures, display "Return details unavailable" message
   */
  is_unavailable?: boolean;
  /** @format int64 */
  original_return_cost?: string;
  /** @format int32 */
  original_return_time_days?: number;
  /** @format int64 */
  return_cost?: string;
  return_policy_text?: string;
  return_policy_url?: string;
  /**
   * time in days to return the item, for both returns and exchanges
   * @format int32
   */
  return_time_days?: number;
  /** true if returns are enabled, false if not, check return_cost for the cost */
  returns_enabled?: boolean;
}

export interface Route {
  shipping_legs?: ShippingLeg[];
}

export interface Sender {
  contact_info?: ContactInfo;
}

/** Session contains details of the session, which was used to create this order. */
export interface Session {
  /**
   *  - UNSPECIFIED: No consent given, no data collection allowed.
   *  - STATISTICAL: Statistical consent given, data can be collected for statistical purposes only.
   *  - PERSONALIZATION: Personalization consent given, data can be collected for personalization purposes.
   */
  consent_level?: ConsentLevel;
  custom_shipping_locations?: CustomShippingLocation[];
  custom_shipping_method?: string;
  /** Listing of Delivery Time Components produced by the Ingrid Delivery Checkout. */
  delivery_promise?: DeliveryPromise;
  /**
   * - UNKNOWN: Delivery type is not known for some reason
   *  - DELIVERY: Home delivery
   *  - PICKUP: Delivery to a service point or a locker
   *  - MAILBOX: Delivery to customer's mailbox
   *  - INSTORE: Delivery to one of the merchants stores
   *  - INWAREHOUSE: Delivery to the warehouse. This type is used with chain delivery in warehouse-warehouse-delivery/pickup.
   */
  delivery_type?: DeliveryType;
  locale?: string;
  meta?: Record<string, string>;
  method?: string;
  pricing?: Pricing;
  returns_promise?: ReturnsPromise;
  /** Common address entity that used almost everywhere in Ingrid's API. */
  search_address?: Address;
  session_id?: string;
  shipping?: Shipping;
  /** Use shipping.category_ref instead. [deprecated] */
  shipping_category_ref?: string;
  /** Use shipping.time_slot instead. [deprecated] */
  time_slot?: TimeSlot;
  tos_id?: string;
}

export interface Shipping {
  addons?: Addon[];
  carrier?: string;
  category_name?: string;
  category_ref?: string;
  external_method_id?: string;
  product?: string;
  time_slot?: TimeSlot;
}

export interface ShippingLeg {
  delivery_type?: string;
  /** LegLocation represents a location that takes part in a delivery. */
  from?: LegLocation;
  shipping_method?: string;
  /** LegLocation represents a location that takes part in a delivery. */
  to?: LegLocation;
}

/** @default "UNKNOWN" */
export type Status = "UNKNOWN" | "ACTIVE" | "ARCHIVED";

export interface TimeSlot {
  end?: string;
  expires?: string;
  id?: string;
  start?: string;
}

/**
 *  - TYPE_CARRIER_DEFAULT: Default addons returned in FetchShippingOptions under default_addons field.
 * Default addons are not presented to end customer in UI (all other delivery addons are presented).
 *  - TYPE_ID_CHECK: Basic identity check – courier verifies recipient’s ID at delivery.
 *  - TYPE_WITHOUT_ID_CHECK: Basic identity check – courier will not verify recipient’s ID at delivery.
 *  - TYPE_DIGITAL_CHECK: Digital identity verification using BankID or similar.
 *  - TYPE_ID_MATCH_RECIPIENT: ID must match the name of the recipient (e.g. delivery only to person on label).
 *  - TYPE_AGE_CHECK: Basic age verification – courier confirms recipient meets age requirement (typically 18+).
 *  - TYPE_EXTENDED_AGE_CHECK: Extended age verification – includes more than one: signature, ID check or digital validation.
 *  - TYPE_AGE_CHECK_16: Age check requiring the recipient to be at least 16 years old.
 *  - TYPE_EXTENDED_AGE_CHECK_16: Extended age check for 16+ –  includes more than one: signature, ID check or digital validation.
 *  - TYPE_AGE_CHECK_18: Age check requiring the recipient to be at least 18 years old.
 *  - TYPE_EXTENDED_AGE_CHECK_18: Extended age check for 18+ – includes more than one: signature, ID check or digital validation.
 *  - TYPE_AGE_CHECK_20: Age check requiring the recipient to be at least 20 years old.
 *  - TYPE_AGE_CHECK_21: Age check requiring the recipient to be at least 21 years old.
 *  - TYPE_EMAIL: Notify recipient via email when shipment status is updated.
 *  - TYPE_SMS: Notify recipient via SMS when shipment status is updated.
 *  - TYPE_LETTER: Notify recipient via physical letter (paper notice, e.g., undeliverable or missed delivery).
 *  - TYPE_CALL: Notify recipient via phone call (automated or manual).
 *  - TYPE_NOTIFICATION: General or fallback notification without specifying the communication channel.
 *  - TYPE_PRE_EMAIL: Notify recipient via email before the shipment is dispatched or delivered (pre-alert).
 *  - TYPE_PRE_SMS: Notify recipient via SMS before the shipment is dispatched or delivered (pre-alert).
 *  - TYPE_PRE_CALL: Notify recipient via phone call before the shipment is dispatched or delivered.
 *  - TYPE_PRE_NOTIFICATION: General pre-notification without specifying channel (can be email, SMS, or call).
 *  - TYPE_WITHOUT_PRE_NOTIFICATION: Shipment proceeds without any pre-notification.
 *  - TYPE_LEAVE_AT_DOOR: Leave the parcel at the recipient’s door or in a designated safe place without requiring interaction.
 *  - TYPE_CARRY_IN: Courier is required to carry the parcel inside the recipient's home or building.
 *  - TYPE_CARRY_OUT: Courier is required to carry the parcel outside the recipient's home or building.
 *  - TYPE_HOME_DELIVERY: Deliver the parcel directly to the recipient’s home address instead of a pickup location or access point.
 *  - TYPE_ENDORSEMENT_ABANDON: Abandon the shipment if it cannot be delivered (no return or retry attempt).
 *  - TYPE_PERSONAL_DELIVERY: Deliver the parcel directly into the hands of the recipient; no drop-off allowed.
 *  - TYPE_INSTALLATION: Perform installation of the delivered item at the recipient's location (e.g., appliances or furniture).
 *  - TYPE_REMOVAL: Remove old items (e.g., used furniture or appliances) from the recipient’s location as part of the delivery service.
 *  - TYPE_RECYCLE: Collect old or used items from the recipient for recycling during the delivery process.
 *  - TYPE_SWAP: Collect old or used items from the recipient during the delivery process and swap with the delivery.
 *  - TYPE_DISABLE_MODIFICATIONS: Prevents the recipient from modifying delivery options, such as changing delivery location, time, or leave-at-door settings.
 *  - TYPE_OPTIONAL_SERVICE_POINT: Allows the recipient to change the pickup location or service point before delivery.
 *  - TYPE_FLEX_CHANGE: Allows the recipient to flexibly change the delivery method, time, or location while the shipment is in transit.
 *  - TYPE_UNWRAPPING: Perform unwrapping on delivered item at recipient's location.
 *  - TYPE_PICKUP_POINT_DELIVERY: Deliver the parcel directly to the pickup location or access point.
 *  - TYPE_MAILBOX_DELIVERY: Deliver the parcel directly to the mailbox directly.
 *  - TYPE_DELIVERY_BEFORE_8: Deliver the parcel before 8:00 AM on the scheduled delivery day.
 *  - TYPE_DELIVERY_BEFORE_9: Deliver the parcel before 9:00 AM on the scheduled delivery day.
 *  - TYPE_DELIVERY_BEFORE_10: Deliver the parcel before 10:00 AM on the scheduled delivery day.
 *  - TYPE_DELIVERY_BEFORE_12: Deliver the parcel before 12:00 PM (noon) on the scheduled delivery day.
 *  - TYPE_EVENING_DELIVERY: Deliver the parcel during the evening hours, typically after 5:00 PM.
 *  - TYPE_EXPRESS_DELIVERY: Prioritize the shipment for the fastest possible delivery, typically within 1–2 days depending on the carrier.
 *  - TYPE_PRIORITY_DELIVERY: Prioritize internal processing of the shipment to improve transit performance (carrier-defined).
 *  - TYPE_SATURDAY_DELIVERY: Deliver the parcel on a Saturday, even if it is outside standard weekday schedules.
 *  - TYPE_SUNDAY_DELIVERY: Deliver the parcel on a Sunday, if available within the carrier’s service area.
 *  - TYPE_SAME_DAY_DELIVERY: Deliver the parcel on the same day it is shipped, usually within a few hours.
 *  - TYPE_TIME_AGREED_DELIVERY: Delivery at a specific time window agreed between the sender and the carrier.
 *  - TYPE_BY_TRUCK: Shipment must be delivered using a truck, typically due to size, weight, or palletized load.
 *  - TYPE_PALLET_TRANSFER: EUR-pallet must be exchanged at the time of delivery.
 *  - TYPE_FRANKED_POSTAGE: Pre-paid postage method where the sender uses a franking machine or online portal to apply postage instead of stamps.
 *  - TYPE_CONTAINER_RENT: Temporary rental of a container or shipping unit required for the transport. Typically used for pallet shipments.
 *  - TYPE_LOADING_ASSISTANCE: Shipment requires mechanical or manual assistance to be loaded onto the vehicle at the pickup location.
 *  - TYPE_UNLOADING_ASSISTANCE: Shipment requires mechanical or manual assistance to be unloaded from the vehicle at the delivery location.
 *  - TYPE_THERMO_COLD: Shipment requires cold temperature handling (e.g., 2–8°C).
 *  - TYPE_THERMO_FROZEN: Shipment must be kept frozen throughout transport. (e.g., below 0°C)
 *  - TYPE_THERMO_WARM: Shipment must be kept warm or above a certain minimum temperature (e.g., 8–25°C).
 *  - TYPE_LONG_GOODS: Item is long or oversized, requiring special handling or space.
 *  - TYPE_PHARMACEUTICALS: Shipment contains pharmaceuticals and may require regulated handling.
 *  - TYPE_DANGEROUS_GOODS: Shipment contains hazardous materials and must comply with safety regulations.
 *  - TYPE_DANGEROUS_GOODS_LQ: Shipment contains a limited quantity of dangerous goods, exempt from full ADR handling.
 *  - TYPE_NON_STACKABLE: Parcel cannot be stacked during transport.
 *  - TYPE_POSTABLE: Parcel can fit directly into a mailbox.
 *  - TYPE_HANGING_GARMENT: Shipment contains garments that must remain hanging during transit.
 *  - TYPE_FRAGILE: Parcel is fragile and must be handled with extra care.
 *  - TYPE_ALCOHOL: Shipment contains alcohol and may require age verification or special handling.
 *  - TYPE_TYRES: Shipment contains tires, often bulky and requiring dedicated space or securing.
 *  - TYPE_NICOTINE: Shipment contains nicotine products and may require legal handling procedures.
 *  - TYPE_HEAVY: Indicates that the shipment is heavy and may require special handling or lifting equipment.
 *  - TYPE_COD: The recipient pays for the goods or shipping upon delivery (cash, card, or local method).
 *  - TYPE_SHIPPING_DISCOUNT: Applies a negotiated discount or subsidy to the shipping cost (usually requires prior agreement).
 *  - TYPE_RECIPIENT_PAYS: The recipient is responsible for covering the shipping cost, typically via invoice or contract with the carrier.
 *  - TYPE_KIND_QUANTITY: Specifies the type and quantity of items in the shipment (e.g., 3 boxes, 2 bottles); often required for customs or tariff purposes.
 *  - TYPE_CREDIT_WITH_INVOICE_DOCUMENTATION: Enables shipment to be billed after delivery via invoice, with official invoice documentation provided.
 *  - TYPE_CREDIT_WITHOUT_INVOICE_DOCUMENTATION: Enables post-delivery billing on credit without requiring formal invoice documentation.
 *  - TYPE_INSURANCE: Provides coverage for loss or damage of the shipment, based on declared value or carrier-specific terms.
 *  - TYPE_TERMINAL_PICKUP: The shipment will not be delivered to the recipient's address but must be picked up from a designated terminal or depot.
 *  - TYPE_PERSONAL_PICKUP: Shipment must be collected in person by the recipient, typically with ID verification, from a post office, store, or pickup point.
 *  - TYPE_RETENTION_EXTENDED: Extends the retention period for the shipment at the pickup location, typically from 7 to 14 days.
 *  - TYPE_RETURN_TO_SENDER: Instructs the carrier to return the shipment to the sender if it cannot be delivered to the recipient.
 *  - TYPE_RETURN_QR_CODE: Allows the recipient to return the shipment using a scannable QR code instead of / along with printed return label.
 *  - TYPE_PRINT_RETURN_LABEL: Enables printing of the return label at a pickup location or drop-off point, instead of requiring the sender to print it in advance.
 *  - TYPE_CLIMATE_COMPENSATION: Offsets the carbon emissions of the shipment by contributing to certified environmental initiatives.
 *  - TYPE_SHIPMENT_CONSOLIDATION: Indicates that multiple shipments are merged into one consolidated delivery, typically for logistical or operational efficiency.
 *  - TYPE_SHIPMENT_MULTI_PARCELS: Indicates that the shipment consists of multiple parcels under a single tracking number or delivery order.
 *  - TYPE_HIDE_CUSTOMER_PHONE: Hides the recipient's phone number from the carrier label or transmission for privacy or regulatory reasons.
 *  - TYPE_HIDE_CUSTOMER_EMAIL: Hides the recipient's email address from the carrier label or transmission for privacy or regulatory reasons.
 *  - TYPE_CUSTOMER_NAME_AS_CARRIER_INSTRUCTIONS: Passes the customer's name as part of delivery instructions, often used to override carrier restrictions or labels.
 *  - TYPE_RESIDENTIAL_ADDRESS_INDICATOR: Marks the delivery address as a residential location, which may affect handling or surcharges.
 *  - TYPE_SPLIT_SHIPMENT: Splits the shipment into multiple parcels or deliveries, typically due to size, weight, or inventory constraints.
 *  - TYPE_HIDE_CUSTOMER_DETAILS: Hides the customer details from the carrier label or transmission for privacy or regulatory reasons.
 *  - TYPE_SIGNATURE: Requires the recipient (or someone at the address) to sign for the shipment upon delivery.
 *  - TYPE_ADULT_SIGNATURE: Requires a legally recognized adult to sign for the shipment, often used for age-restricted deliveries.
 *  - TYPE_INDIRECT_SIGNATURE: Allows someone other than the primary recipient (e.g., neighbor or receptionist) to sign for the shipment.
 *  - TYPE_WITHOUT_POD: The carrier will deliver the package without collecting a signature or proof of delivery.
 *  - TYPE_SIGNATURE_PHOTO_POD: Captures a photo as proof of delivery, often showing the parcel at the drop-off location.
 *  - TYPE_EXTENDED_SIGNATURE_POD: Includes multiple proof of deliveries, such as a high-resolution image, signature, timestamp, and geolocation.
 * @default "TYPE_UNKNOWN"
 */
export type Type =
  | "TYPE_UNKNOWN"
  | "TYPE_CUSTOM"
  | "TYPE_RETURN"
  | "TYPE_CARRIER"
  | "TYPE_CARRIER_DEFAULT"
  | "TYPE_ID_CHECK"
  | "TYPE_WITHOUT_ID_CHECK"
  | "TYPE_DIGITAL_CHECK"
  | "TYPE_ID_MATCH_RECIPIENT"
  | "TYPE_AGE_CHECK"
  | "TYPE_EXTENDED_AGE_CHECK"
  | "TYPE_AGE_CHECK_16"
  | "TYPE_EXTENDED_AGE_CHECK_16"
  | "TYPE_AGE_CHECK_18"
  | "TYPE_EXTENDED_AGE_CHECK_18"
  | "TYPE_AGE_CHECK_20"
  | "TYPE_AGE_CHECK_21"
  | "TYPE_EMAIL"
  | "TYPE_SMS"
  | "TYPE_LETTER"
  | "TYPE_CALL"
  | "TYPE_NOTIFICATION"
  | "TYPE_PRE_EMAIL"
  | "TYPE_PRE_SMS"
  | "TYPE_PRE_CALL"
  | "TYPE_PRE_NOTIFICATION"
  | "TYPE_WITHOUT_PRE_NOTIFICATION"
  | "TYPE_LEAVE_AT_DOOR"
  | "TYPE_CARRY_IN"
  | "TYPE_CARRY_OUT"
  | "TYPE_HOME_DELIVERY"
  | "TYPE_ENDORSEMENT_ABANDON"
  | "TYPE_PERSONAL_DELIVERY"
  | "TYPE_INSTALLATION"
  | "TYPE_REMOVAL"
  | "TYPE_RECYCLE"
  | "TYPE_SWAP"
  | "TYPE_DISABLE_MODIFICATIONS"
  | "TYPE_OPTIONAL_SERVICE_POINT"
  | "TYPE_FLEX_CHANGE"
  | "TYPE_UNWRAPPING"
  | "TYPE_PICKUP_POINT_DELIVERY"
  | "TYPE_MAILBOX_DELIVERY"
  | "TYPE_DELIVERY_BEFORE_8"
  | "TYPE_DELIVERY_BEFORE_9"
  | "TYPE_DELIVERY_BEFORE_10"
  | "TYPE_DELIVERY_BEFORE_12"
  | "TYPE_EVENING_DELIVERY"
  | "TYPE_EXPRESS_DELIVERY"
  | "TYPE_PRIORITY_DELIVERY"
  | "TYPE_SATURDAY_DELIVERY"
  | "TYPE_SUNDAY_DELIVERY"
  | "TYPE_SAME_DAY_DELIVERY"
  | "TYPE_TIME_AGREED_DELIVERY"
  | "TYPE_BY_TRUCK"
  | "TYPE_PALLET_TRANSFER"
  | "TYPE_FRANKED_POSTAGE"
  | "TYPE_CONTAINER_RENT"
  | "TYPE_LOADING_ASSISTANCE"
  | "TYPE_UNLOADING_ASSISTANCE"
  | "TYPE_THERMO_COLD"
  | "TYPE_THERMO_FROZEN"
  | "TYPE_THERMO_WARM"
  | "TYPE_LONG_GOODS"
  | "TYPE_PHARMACEUTICALS"
  | "TYPE_DANGEROUS_GOODS"
  | "TYPE_DANGEROUS_GOODS_LQ"
  | "TYPE_NON_STACKABLE"
  | "TYPE_POSTABLE"
  | "TYPE_HANGING_GARMENT"
  | "TYPE_FRAGILE"
  | "TYPE_ALCOHOL"
  | "TYPE_TYRES"
  | "TYPE_NICOTINE"
  | "TYPE_HEAVY"
  | "TYPE_COD"
  | "TYPE_SHIPPING_DISCOUNT"
  | "TYPE_RECIPIENT_PAYS"
  | "TYPE_KIND_QUANTITY"
  | "TYPE_CREDIT_WITH_INVOICE_DOCUMENTATION"
  | "TYPE_CREDIT_WITHOUT_INVOICE_DOCUMENTATION"
  | "TYPE_INSURANCE"
  | "TYPE_TERMINAL_PICKUP"
  | "TYPE_PERSONAL_PICKUP"
  | "TYPE_RETENTION_EXTENDED"
  | "TYPE_RETURN_TO_SENDER"
  | "TYPE_RETURN_QR_CODE"
  | "TYPE_PRINT_RETURN_LABEL"
  | "TYPE_CLIMATE_COMPENSATION"
  | "TYPE_SHIPMENT_CONSOLIDATION"
  | "TYPE_SHIPMENT_MULTI_PARCELS"
  | "TYPE_HIDE_CUSTOMER_PHONE"
  | "TYPE_HIDE_CUSTOMER_EMAIL"
  | "TYPE_CUSTOMER_NAME_AS_CARRIER_INSTRUCTIONS"
  | "TYPE_RESIDENTIAL_ADDRESS_INDICATOR"
  | "TYPE_SPLIT_SHIPMENT"
  | "TYPE_HIDE_CUSTOMER_DETAILS"
  | "TYPE_SIGNATURE"
  | "TYPE_ADULT_SIGNATURE"
  | "TYPE_INDIRECT_SIGNATURE"
  | "TYPE_WITHOUT_POD"
  | "TYPE_SIGNATURE_PHOTO_POD"
  | "TYPE_EXTENDED_SIGNATURE_POD";

export interface UpdateOrderRequest {
  cart?: Cart;
  external?: External;
  id?: string;
  notes?: Notes;
  receiver?: Receiver;
  route?: Route;
  sender?: Sender;
  /** Session contains details of the session, which was used to create this order. */
  session?: Session;
  status?: Status;
}

export interface UpdateOrderResponse {
  order?: Order;
}

export interface Error {
  /** @format int32 */
  code?: number;
  details?: Any[];
  message?: string;
}

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({ ...axiosConfig, baseURL: axiosConfig.baseURL || "/v1/tos" });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title TOS API
 * @version 1.0
 * @baseUrl /v1/tos
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @name TosAddReferenceToOrder
   * @summary Add reference to order.
   * @request POST:/order.addReference
   * @secure
   */
  tosAddReferenceToOrder = (body: AddReferenceToOrderRequest, params: RequestParams = {}) =>
    this.request<AddReferenceToOrderResponse, Error>({
      path: `/**/order.addReference`,
      method: "POST",
      body: body,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * No description
   *
   * @name TosCountOrders
   * @summary Count orders.
   * @request GET:/order.count
   * @secure
   */
  tosCountOrders = (
    query?: {
      "filtering.created_at.from"?: string;
      "filtering.created_at.to"?: string;
      "filtering.updated_at.from"?: string;
      "filtering.updated_at.to"?: string;
      /** Id matches external_id, session_id and all ids with the specified value in prefix. */
      "filtering.id"?: string;
      "filtering.statuses"?: ("UNKNOWN" | "ACTIVE" | "ARCHIVED")[];
      "filtering.sources"?: string[];
      /** Use id instead. [deprecated] */
      "filtering.external_id"?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<CountOrdersResponse, Error>({
      path: `/**/order.count`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * No description
   *
   * @name TosCreateOrder
   * @summary Create an Order.
   * @request POST:/order.create
   * @secure
   */
  tosCreateOrder = (body: CreateOrderRequest, params: RequestParams = {}) =>
    this.request<CreateOrderResponse, Error>({
      path: `/**/order.create`,
      method: "POST",
      body: body,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * No description
   *
   * @name TosGetOrder
   * @summary Get an Order.
   * @request GET:/order.get
   * @secure
   */
  tosGetOrder = (
    query?: {
      id?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<GetOrderResponse, Error>({
      path: `/**/order.get`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * No description
   *
   * @name TosListOrders
   * @summary List orders. Default sorting puts newest orders first.
   * @request GET:/order.list
   * @secure
   */
  tosListOrders = (
    query?: {
      /**
       * Deprecated, use pagination.limit instead.
       * @format uint64
       */
      limit?: number;
      /** @default "CREATED_AT" */
      order_by?: "CREATED_AT" | "UPDATED_AT";
      /** @default "DESCENDING" */
      order_by_direction?: "DESCENDING" | "ASCENDING";
      "filtering.created_at.from"?: string;
      "filtering.created_at.to"?: string;
      "filtering.updated_at.from"?: string;
      "filtering.updated_at.to"?: string;
      /** Id matches external_id, session_id and all ids with the specified value in prefix. */
      "filtering.id"?: string;
      "filtering.statuses"?: ("UNKNOWN" | "ACTIVE" | "ARCHIVED")[];
      "filtering.sources"?: string[];
      /** Use id instead. [deprecated] */
      "filtering.external_id"?: string;
      /** @format uint64 */
      "pagination.offset"?: number;
      /** @format uint64 */
      "pagination.limit"?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<ListOrdersResponse, Error>({
      path: `/**/order.list`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * No description
   *
   * @name TosUpdateOrder
   * @summary Update an Order.
   * @request POST:/order.update
   * @secure
   */
  tosUpdateOrder = (body: UpdateOrderRequest, params: RequestParams = {}) =>
    this.request<UpdateOrderResponse, Error>({
      path: `/**/order.update`,
      method: "POST",
      body: body,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * No description
   *
   * @name TosListOrdersLog
   * @summary List most recently updated orders.
   * @request POST:/orders.log
   * @secure
   */
  tosListOrdersLog = (body: ListOrdersLogRequest, params: RequestParams = {}) =>
    this.request<ListOrdersLogResponse, Error>({
      path: `/**/orders.log`,
      method: "POST",
      body: body,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
